import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Paper } from '@material-ui/core';
import { CARD_VARIANTS } from '../../theme/otherColors';
import { convertSpacingToCss } from '../../helpers/stylesHelpers';

const useStyles = makeStyles({
  rootCards: {
    borderRadius: props => props.borderRadius,
    padding: props => (props.padding ? convertSpacingToCss(props.padding) : 0),
  },
});

const Card = ({
  noBorder,
  className,
  children,
  variant,
  borderRadius,
  padding,
}) => {
  const styles = {
    borderRadius,
    padding,
  };
  const classes = useStyles(styles);
  return (
    <Paper
      spacing={3}
      elevation={0}
      className={`${classes.rootCards} ${className}`}
      style={{
        border: noBorder ? '' : `1px solid ${CARD_VARIANTS[variant].border}`,
        background: CARD_VARIANTS[variant].background,
      }}
    >
      {children}
    </Paper>
  );
};

Card.defaultProps = {
  noBorder: false,
  className: '',
  padding: 'zero',
};

Card.propTypes = {
  children: PropTypes.element.isRequired,
  noBorder: PropTypes.bool,
  variant: PropTypes.oneOf(
    Object.keys(CARD_VARIANTS).map(variant => CARD_VARIANTS[variant].code)
  ).isRequired,
  className: PropTypes.string,
  borderRadius: PropTypes.number.isRequired,
  padding: PropTypes.string,
};

export default Card;
